import { render, staticRenderFns } from "./reusablePrintPallet.vue?vue&type=template&id=2d6f50a0"
import script from "./reusablePrintPallet.vue?vue&type=script&lang=js"
export * from "./reusablePrintPallet.vue?vue&type=script&lang=js"
import style0 from "./reusablePrintPallet.vue?vue&type=style&index=0&id=2d6f50a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports